import { Popover } from '@base-ui/react/popover'
import { twMerge } from 'tailwind-merge'
import { popupSurface } from '../../../lib/list-styles'
import { Interactive } from '../../interactive'
import type { PartProps } from '../../../lib/part-props'

interface PopoverPopupProps extends PartProps<Popover.Popup.Props> {
  className?: string
}

/** Registers its bounds in the overlay for the same reason `Menu.Popup` does. */
function PopoverPopup({ className, children, ...props }: PopoverPopupProps) {
  return (
    <Popover.Popup
      className={twMerge(
        popupSurface,
        // `relative` for the bounds tracker, as in Menu.Popup.
        'pointer-events-auto relative w-72 p-3 text-sm',
        className,
      )}
      {...props}
    >
      <Interactive>{children}</Interactive>
    </Popover.Popup>
  )
}

export { PopoverPopup }
